import React, { useEffect } from 'react';

function LogistikHandel() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" role="main">
      <section className="hero hero--small">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">
                Logistik & Handel <span className="hero__highlight">Recruiting Berlin</span>
              </h1>
              <p className="hero__subtitle">
                Personalgewinnung für Logistik und Handel in Berlin: Lagerarbeiter, Verkäufer, Führungskräfte über Social Media. Lokale Netzwerke und effiziente Strategien seit 2009.
              </p>
              <div className="hero__cta">
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Hero CTA">Kostenloses Erstgespräch</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Logistik & Handel Recruiting: Effiziente Personalgewinnung in Berlin</h2>
            <p className="section-subtitle">
              Logistik und Handel sind tragende Säulen der Berliner Wirtschaft. Bei famefact spezialisieren wir uns auf Recruiting für diese Branchen über Social Media – von Lagerarbeitern bis zu Führungskräften.
            </p>
          </div>

          <div className="content-grid">
            <div className="content-text">
              <h3>Warum Logistik-Recruiting in Berlin über Social Media erfolgreich ist</h3>
              <p>
                Die Logistik- und Handelsbranche ist das Rückgrat der Berliner Wirtschaft. Mit über 180.000 Beschäftigten im Handel und weiteren 100.000 in der Logistik ist diese Branche einer der größten Arbeitgeber der Hauptstadt. Der Fachkräftemangel ist real: 40% der offenen Stellen bleiben länger als 3 Monate unbesetzt.
              </p>
              <p>
                Social Media hat sich als revolutionärer Kanal etabliert. Unsere Strategie basiert auf: <strong>Präzises lokales Targeting, authentische Einblicke in den Arbeitsalltag und mobile-first Ansprache.</strong> Durch Geotargeting sprechen wir Kandidaten in spezifischen Berliner Bezirken an.
              </p>

              <div className="stats-grid">
                <div className="stat-box">
                  <span className="stat-box__number">8-15€</span>
                  <span className="stat-box__label">Pro Bewerbung</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">180.000+</span>
                  <span className="stat-box__label">Handel-Beschäftigte</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">100.000+</span>
                  <span className="stat-box__label">Logistik-Jobs</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">40%</span>
                  <span className="stat-box__label">Unbesetzte Stellen</span>
                </div>
              </div>

              <h3>Unsere Logistik & Handel Recruiting Services</h3>
              
              <h4>1. Lager- und Transportpersonal</h4>
              <ul>
                <li>Lagerarbeiter und Kommissionierer</li>
                <li>Fahrer und Transportpersonal</li>
                <li>Lagerleiter und Schichtführer</li>
                <li>Logistik-Koordinatoren</li>
              </ul>

              <h4>2. Verkaufs- und Servicepersonal</h4>
              <ul>
                <li>Verkäufer und Kassierer</li>
                <li>Filialleiter und Abteilungsleiter</li>
                <li>Customer Service Mitarbeiter</li>
                <li>Store Manager</li>
              </ul>

              <h4>3. Führungskräfte und Management</h4>
              <ul>
                <li>Operations Manager</li>
                <li>Supply Chain Manager</li>
                <li>Regional Manager</li>
                <li>Logistik-Direktoren</li>
              </ul>

              <div className="cta-box">
                <h3>Kostenlose Logistik-Analyse</h3>
                <p>Vereinbaren Sie Ihre kostenlose Analyse für Logistik-Recruiting.</p>
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Content CTA">Kostenloses Erstgespräch</button>
              </div>
            </div>

            <div className="content-sidebar">
              <div className="sidebar-widget">
                <h3>Logistik-Positionen</h3>
                <ul>
                  <li>✓ Lagerarbeiter</li>
                  <li>✓ Fahrer</li>
                  <li>✓ Verkäufer</li>
                  <li>✓ Manager</li>
                  <li>✓ Koordinatoren</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Kontakt</h3>
                <p>
                  famefact Social Recruiting Berlin<br />
                  Schliemannstraße 23<br />
                  10437 Berlin<br />
                  <a href="tel:+4930403665430">030 403 665 430</a><br />
                  <a href="mailto:info@famefact.com">info@famefact.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default LogistikHandel;
